import { Box, IconButton, Stack, Typography } from "@mui/material";
import { useLocation } from "react-router";
import Iconify from "src/components/iconify";
import { paths } from "src/routes/paths";
import { useQueryParams, StringParam } from "use-query-params";

const ChosenFiltersView = ({ onEdit }: { onEdit?: () => void }) => {
  const { pathname } = useLocation();

  const isInCustomDashboard = pathname.includes(paths.custom.root);

  const [query] = useQueryParams({
    keyword: StringParam,
    start_date: StringParam,
    end_date: StringParam,
    platform: StringParam,
    sentiment: StringParam,
    language: StringParam,
    author_verified: StringParam,
  });

  const filters = [
    {
      key: "date",
      label: "Date",
      value: query.start_date && query.end_date ? `${query.start_date} - ${query.end_date}` : null,
    },
    {
      key: "keyword",
      label: "Keyword",
      value:
        !isInCustomDashboard && query.keyword
          ? query.keyword
              .split(",")
              .slice(0, 2)
              .join(", ")
              .concat(query.keyword.split(",").length > 2 ? "..." : "")
          : null,
    },
    {
      key: "sentiment",
      label: "Sentiment",
      value: query.sentiment
        ? query.sentiment
            .split(",")
            .slice(0, 2)
            .join(", ")
            .concat(query.sentiment.split(",").length > 2 ? "..." : "")
        : null,
    },
    {
      key: "language",
      label: "Language",
      value: query.language
        ? query.language
            .split(",")
            .slice(0, 2)
            .join(", ")
            .concat(query.language.split(",").length > 2 ? "..." : "")
        : null,
    },
    {
      key: "author_verified",
      label: "Author verified",
      value: query.author_verified
        ? query.author_verified
            .split(",")
            .slice(0, 2)
            .join(", ")
            .concat(query.author_verified.split(",").length > 2 ? "..." : "")
        : null,
    },
  ];

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap">
      {filters
        .filter((f) => f.value)
        .map((filter) => (
          <Box
            key={filter.key}
            sx={{
              px: 2,
              py: 1,
              borderRadius: 2,
              border: "1px dashed #E0E0E0",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography variant="body2" fontWeight={600} color="text.secondary">
              {filter.label}:
            </Typography>
            <Typography noWrap variant="body2">
              {filter.value}
            </Typography>
            <IconButton size="small" onClick={() => onEdit?.()}>
              <Iconify icon="eva:edit-2-outline" width={16} />
            </IconButton>
          </Box>
        ))}
    </Stack>
  );
};

export default ChosenFiltersView;
